import PPUtils from "./PPUtils"
import GraphQL from "./GraphQLClient"

const UPDATE_USER_SETTINGS_LOCALSTORAGE = `mutation ($userId: Long, $localstorage: String) {
     updateUserSettingsLocalstorage(userId: $userId, localstorage: $localstorage)
}`

export function collectSettingsLocalstorage() {
     const jsonArr = {}
     Object.keys(localStorage).forEach((key) => {
          if (key !== "login" && key !== "presetId") {
               jsonArr[key] = localStorage.getItem(key)
          }
     })
     return JSON.stringify(jsonArr)
}

export function persistUserSettingsLocalstorage() {
     try {
          const auth = PPUtils.getLogin()
          const userId = auth?.user?.id
          if (userId == null || !auth?.token) {
               return
          }
          const localstorage = collectSettingsLocalstorage()
          GraphQL.getClient()
               .request(UPDATE_USER_SETTINGS_LOCALSTORAGE, { userId, localstorage })
               .catch(() => {
                    // backend persistence failing should not break the UI
               })
          auth.user.configSettingsLocalstorage = localstorage
          PPUtils.updateLogin(auth)
          if (typeof window !== "undefined") {
               window.dispatchEvent(new Event("pp-user-settings-updated"))
          }
     } catch {
          // localStorage/GraphQL blocked (e.g. private mode / iframe)
     }
}
